"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSearch = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconSearch = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "m19.439 20.753-6.331-6.331c-.5.396-1.113.707-1.838.931a7.24 7.24 0 0 1-2.154.338c-1.876 0-3.464-.65-4.765-1.95-1.3-1.3-1.95-2.888-1.95-4.764 0-1.875.65-3.463 1.95-4.765 1.3-1.3 2.888-1.951 4.763-1.951s3.464.65 4.765 1.95c1.301 1.3 1.952 2.889 1.952 4.765 0 .73-.107 1.438-.322 2.121a5.655 5.655 0 0 1-.922 1.796l6.355 6.356-1.503 1.504ZM9.116 13.54c1.288 0 2.371-.439 3.249-1.316.877-.878 1.316-1.96 1.316-3.25 0-1.288-.439-2.37-1.316-3.248-.878-.878-1.96-1.317-3.25-1.317-1.288 0-2.37.44-3.248 1.317-.878.877-1.317 1.96-1.317 3.249 0 1.288.439 2.371 1.317 3.249.877.877 1.96 1.316 3.249 1.316Z"
}));
exports.IconSearch = IconSearch;
//# sourceMappingURL=IconSearch.js.map